export default __webpack_public_path__ + "static/media/height.66c175ba.png";